import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Box, Divider, Typography } from '@mui/material';
import clsx from 'clsx';
import { isRouteRestricted } from 'helper/utility';
import PropTypes from 'prop-types';

import { fetchAdminInformationAction } from 'redux/actions/auth';

import styles from '../sidebar.module.css';

import { navigationGroups } from '../constant';
import { getActiveItemId } from '../helper/utilities';
import NavItem from './NavItem';

function NavigationList({
    user,
    token,
    adminData,
    fetchAdminInformationAction,
    collapseMenu,
    className,
}) {
    const location = useLocation();
    const activeItemId = getActiveItemId(location.pathname);
    const [openItemId, setOpenItemId] = useState(activeItemId);

    // Only one menu stays open, and moving to another section closes it.
    useEffect(() => {
        setOpenItemId(activeItemId);
    }, [activeItemId]);

    const toggleItem = (id) => {
        setOpenItemId(openItemId === id ? null : id);
    };

    useEffect(() => {
        if (!adminData) {
            fetchAdminInformationAction(token);
        }
    }, [fetchAdminInformationAction, adminData, token]);

    return (
        <Box
            component="nav"
            aria-label="Main"
            className={clsx(styles.sidebarNav, className)}
            data-tour="nav"
        >
            {navigationGroups.map((group) => (
                <Box key={group.id} className={styles.navGroup}>
                    {group.label && !collapseMenu && (
                        <Typography component="h2" className={styles.navGroupLabel}>
                            {group.label}
                        </Typography>
                    )}
                    {group.label && collapseMenu && <Divider className={styles.navGroupDivider} />}
                    {group.items
                        .filter((item) => !isRouteRestricted(item.label, user))
                        .map((item) => (
                            <NavItem
                                key={item.id}
                                item={item}
                                isActive={item.id === activeItemId}
                                isOpen={item.id === openItemId}
                                onToggle={toggleItem}
                                collapsed={collapseMenu}
                                adminType={adminData?.type}
                                user={user}
                            />
                        ))}
                </Box>
            ))}
        </Box>
    );
}

NavigationList.propTypes = {
    user: PropTypes.object.isRequired,
    adminData: PropTypes.object,
    fetchAdminInformationAction: PropTypes.func,
    token: PropTypes.string,
    collapseMenu: PropTypes.bool,
    className: PropTypes.string,
};

function mapStateToProps(state) {
    return {
        user: state.auth?.userData?.user,
        adminData: state.auth?.adminData,
        token: state.auth?.userData.token,
    };
}

export default connect(mapStateToProps, { fetchAdminInformationAction })(NavigationList);
